import React from 'react';
import Heading2 from '@Components/heading_2/view';
import Heading3 from '@Components/heading_3/view';
import s from '../styles/DetailContent.module.css';

const Knowledge22 = () => {
    return (
        <div className={s.wrapper}>
            <section className={s.section}>
                <Heading2 title='リゾートトラストグループとは？' fontWeight={700} />
                <p>
                    リゾートトラストグループとは、リゾートトラスト株式会社が運営するゴルフ場のことです。リゾートトラストが運営するゴルフ場は全国に13ヶ所あります。（※2024年7月現在）
                </p>
                <div className={s.h4_link}>
                    ・
                    <a href='https://juchi.jp/courses/1124' className={s.link}>
                        グランディ那須白河ゴルフ倶楽部（福島県）
                    </a>
                </div>
                <div className={s.h4_link}>
                    ・
                    <a href='https://juchi.jp/courses/400' className={s.link}>
                        メイプルポイントゴルフクラブ（山梨県）
                    </a>
                </div>
                <div className={s.h4_link}>
                    ・
                    <a href='https://juchi.jp/courses/898' className={s.link}>
                        グランディ軽井沢ゴルフクラブ（長野県）
                    </a>
                </div>
                <div className={s.h4_link}>
                    ・
                    <a href='https://juchi.jp/courses/310' className={s.link}>
                        グランディ浜名湖ゴルフクラブ（静岡県）
                    </a>
                </div>
                <div className={s.h4_link}>
                    ・
                    <a href='https://juchi.jp/courses/426' className={s.link}>
                        スプリングフィールドゴルフクラブ（岐阜県）
                    </a>
                </div>
                <div className={s.h4_link}>
                    ・
                    <a href='https://juchi.jp/courses/381' className={s.link}>
                        パインズゴルフクラブ（愛知県）
                    </a>
                </div>
                <div className={s.h4_link}>
                    ・
                    <a href='https://juchi.jp/courses/369' className={s.link}>
                        セントクリークゴルフクラブ（愛知県）
                    </a>
                </div>
                <div className={s.h4_link}>
                    ・
                    <a href='https://juchi.jp/courses/363' className={s.link}>
                        ザ・トラディションゴルフクラブ（愛知県）
                    </a>
                </div>
                <div className={s.h4_link}>
                    ・
                    <a href='https://juchi.jp/courses/459' className={s.link}>
                        グレイスヒルズカントリー俱楽部（三重県）
                    </a>
                </div>
                <div className={s.h4_link}>
                    ・
                    <a href='https://juchi.jp/courses/855' className={s.link}>
                        ザ・カントリークラブ（滋賀県）
                    </a>
                </div>
                <div className={s.h4_link}>
                    ・
                    <a href='https://juchi.jp/courses/518' className={s.link}>
                        関西ゴルフ俱楽部（兵庫県）
                    </a>
                </div>
                <div className={s.h4_link}>
                    ・
                    <a href='https://juchi.jp/courses/577' className={s.link}>
                        オークモントゴルフクラブ（奈良県）
                    </a>
                </div>
                <div className={s.h4_link}>
                    ・
                    <a href='https://juchi.jp/courses/1066' className={s.link}>
                        グランディ鳴門ゴルフクラブ36（徳島県）
                    </a>
                </div>
            </section>

            <section className={s.section}>
                <Heading2 title='リゾートトラストグループのゴルフ会員権の特典とは？' fontWeight={700} />
                <p>リゾートトラストグループで用意されている様々な特典をご紹介します。</p>

                <Heading3 title='グループゴルフ場の相互利用が可能' />
                <p>
                    他リゾートトラストグループゴルフ場のグリーンフィーが半額で利用可能であったり、曜日によってはメンバーフィーでプレーを行うことが可能です。
                </p>

                <Heading3 title='リゾートトラストホテルの利用が可能' />
                <p>
                    リゾートトラストグループのゴルフ場の会員になることで、エクシブ、リゾーピア、サンメンバーズ系ホテルに年間2泊することが可能です。
                </p>

                <Heading3 title='リゾートトラストグループ共通ポイントが貯まる・使える' />
                <p>
                    リゾートトラストグループが運営するホテル、ゴルフ場、レストランなどの利用に応じてポイントを獲得することができ、獲得したポイントはリゾートトラストグループの対象施設でのサービスに利用することが可能です。
                </p>
                <p>※これらの特典は、ゴルフ場や時期により条件が異なるため、詳しくはゴルフ場にお問合せください。</p>
            </section>

            <section className={s.section}>
                <Heading2 title='リゾートトラストグループのおすすめのゴルフ場は？' fontWeight={700} />
                <p>
                    リゾートトラストグループの全国のゴルフ場一覧は
                    <a href='https://juchi.jp/courses?series_id=60' className={s.link}>
                        こちら
                    </a>
                    よりご確認ください。
                    <br />
                    その中でも弊社でよくお取引のあるゴルフ場の一部をご紹介します。
                </p>
                <Heading3 title='リゾートトラストのコースを一部ご紹介' />
                <div className={s.h4_link}>
                    ・<a href='https://juchi.jp/courses/369'>セントクリークゴルフクラブ</a>
                </div>
                セントクリークゴルフクラブは、ジャックニクラウスが設計しており、グリーン周りに池やバンカーが巧みに配置された攻略を楽しめる全27ホールのコースです。
                <br />
                コースのみならずメンテナンス、従業員の対応に関してもメンバー・ビジター問わず非常に好評です。
                <br />
                クラブハウスはゴルフコース発祥のスコットランド地方にちなんだ石造りを主体とした重厚感溢れる造りをしている点も人気です。
                <br />
                <div className={s.h4_link}>
                    ・<a href='https://juchi.jp/courses/518'>関西ゴルフクラブ</a>
                </div>
                関西ゴルフ倶楽部は、高低差は少ないものの10個の池がアクセントになっており戦略性の求められる全18ホールの林間コースです。
                <br />
                2024年5月にはリゾートトラストレディスが開催されたり、法人接待にも多く使われてきたゴルフ場だからこそ、豪華絢爛なクラブハウス、メンテナンスの行き届いた美しいフェアウェイ・グリーンが人気です。
                <br />
            </section>

            <section className={s.section}>
                <Heading2 title='リゾートトラストグループの会員権をご購入された会員様の声' fontWeight={700} />
                <p>
                    住地ゴルフにて
                    <a href='https://juchi.jp/courses/369' className={s.link}>
                        セントクリークゴルフクラブ
                    </a>
                    、
                    <a href='https://juchi.jp/courses/363' className={s.link}>
                        ザ・トラディションゴルフクラブ
                    </a>
                    の会員権をご購入された会員様にインタビューさせていただきました。
                    <br />
                    ぜひ会員権のご購入にお役立てください。
                    <br />
                    <br />
                    セントクリークゴルフクラブ、ザ・トラディションゴルフクラブの会員様の声は
                    <a href='https://juchi.jp/member_voices/11' className={s.link}>
                        こちら
                    </a>
                    。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='ゴルフ会員権に関するご相談は住地ゴルフへ' fontWeight={700} />
                <p>
                    上述のように、リゾートトラストグループでは他にはない特有の特典が多数あります。
                    <br />
                    また、ゴルフ場やホテルの相互利用のメリットもあるため、ゴルフだけでなく家族旅行などでの利用をお考えの方からも人気を集めています。
                    <br />
                    具体的なコースの特徴や売買状況については、お気軽に弊社にお問合せください。
                </p>
            </section>
        </div>
    );
};

export default Knowledge22;
